import {
  descriptionUI,
  radioSchema,
  radioUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { capitalizeFirst } from 'platform/shared/health-apps';
import BirthSexAddtlInfo from '../../components/FormDescriptions/BirthSexAddtlInfo';
import {
  blankSchema,
  DEFAULT_TITLE_OPTS,
  titleWithNameUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['applicants--birth-sex-title'];
const INPUT_LABEL = content['applicants--birth-sex-label'];

const SCHEMA_ENUM = ['female', 'male'];
const SCHEMA_LABELS = Object.fromEntries(
  SCHEMA_ENUM.map(key => [key, capitalizeFirst(key)]),
);

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.applicant),
    applicantGender: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
    'view:addtlInfo': descriptionUI(BirthSexAddtlInfo),
  },
  schema: {
    type: 'object',
    required: ['applicantGender'],
    properties: {
      applicantGender: radioSchema(SCHEMA_ENUM),
      'view:addtlInfo': blankSchema,
    },
  },
};
